import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, MenuItem, MenuItemPercentile } from './QueryArguments.styles';
import { Analysis, EventCollection, TargetProperty, Timeframe, Percentile } from '../../components';
import { showField } from '../../utils';
import { selectEventCollection, selectTargetProperty, selectAnalysis, getEventCollection, getAnalysis, getTargetProperty, getTimeframe, getTimezone, getPercentile, selectTimezone, setTimeframe, setPercentile, DEFAULT_TIMEFRAME } from '../../modules/query';
import { getDefaultTimezone } from '../../modules/timezone';
import { resetChartSettings } from '../../modules/chartSettings';
import { AppContext } from '../../contexts';

var App = function App() {
  var dispatch = useDispatch();
  var analysis = useSelector(getAnalysis);
  var collection = useSelector(getEventCollection);
  var timeframe = useSelector(getTimeframe);
  var targetProperty = useSelector(getTargetProperty);
  var defaultTimezone = useSelector(getDefaultTimezone);
  var timezone = useSelector(getTimezone);
  var percentile = useSelector(getPercentile);

  var _useContext = useContext(AppContext),
      onUpdateChartSettings = _useContext.onUpdateChartSettings;

  return React.createElement(Container, null, React.createElement(MenuItem, null, React.createElement(Analysis, {
    analysis: analysis,
    onChange: function onChange(updatedAnalysis) {
      dispatch(selectAnalysis(updatedAnalysis));
      dispatch(resetChartSettings());
      onUpdateChartSettings({});
    }
  })), showField('percentile', analysis) && React.createElement(MenuItemPercentile, null, React.createElement(Percentile, {
    value: percentile,
    onReset: function onReset() {
      return dispatch(setPercentile(null));
    },
    onChange: function onChange(value) {
      return dispatch(setPercentile(value));
    }
  })), showField('eventCollection', analysis) && React.createElement(MenuItem, null, React.createElement(EventCollection, {
    collection: collection,
    onReset: function onReset() {
      return dispatch(selectEventCollection(null));
    },
    onChange: function onChange(collection) {
      return dispatch(selectEventCollection(collection));
    }
  })), showField('targetProperty', analysis) && React.createElement(MenuItem, null, React.createElement(TargetProperty, {
    analysis: analysis,
    collection: collection,
    property: targetProperty,
    onChange: function onChange(property) {
      dispatch(selectTargetProperty(property));
    }
  })), showField('timeframe', analysis) && React.createElement(MenuItem, null, React.createElement(Timeframe, {
    id: "timeframe",
    value: timeframe,
    timezone: timezone,
    onReset: function onReset() {
      dispatch(setTimeframe(DEFAULT_TIMEFRAME));
      dispatch(selectTimezone(defaultTimezone));
    },
    onTimeframeChange: function onTimeframeChange(timeframe) {
      return dispatch(setTimeframe(timeframe));
    },
    onTimezoneChange: function onTimezoneChange(timezone) {
      return dispatch(selectTimezone(timezone));
    }
  })));
};

export default App;